import React from 'react';
import { Crown, Heart, Mail, Phone, MapPin, Clock, FileText, Shield, Instagram, Facebook, Twitter, ExternalLink } from 'lucide-react';

const EnhancedFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="enhanced-footer">
      <div className="footer-content">
        {/* 会社情報セクション */}
        <div className="footer-section">
          
          <div className="company-info">
            <h4 className="info-heading">運営会社</h4>
            <p className="company-name">株式会社K.Platinum</p>
            <div className="company-details">
              <div className="company-detail">
                <MapPin size={14} />
                〒133-0057 <br />東京都江戸川区西小岩5-10-24
              </div>
              <div className="company-detail">
                <Phone size={14} />
                070-9093-1557
              </div>
            </div>
          </div>
        </div>


      </div>

      {/* 認証・パートナー情報 */}

      {/* フッター下部 */}
    </footer>
  );
};

export default EnhancedFooter;